import * as eligibilityActions from '../actions/eligibilityActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === eligibilityActions.ELIGIBILITY_RESPONSE) {
    return {
      ...state,
      responseData: {
        ...action.data.data,
      },
    };
  }
  return state;
};
